import { currencyConstants } from "../actions/currency";

const defaultState = {
  status: {
    started: false,
    saving: false,
    error: false,
    ended: false
  },
  currencies: null
};

export function currencyList(state = defaultState, { type, payload, error }) {
  switch (type) {
  case currencyConstants.CLEAR_CURRENCY_LIST:
    return defaultState;
  case currencyConstants.GET_CURRENCY_LIST_START:
    return {
      ...state,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case currencyConstants.GET_CURRENCY_LIST_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        error: false,
        ended: true
      },
      currencies: payload
    };
  case currencyConstants.GET_CURRENCY_LIST_ERROR:
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return state;
  }
}
